import { ref } from "vue";
import { defineStore } from "pinia";
import { toast } from "vue3-toastify";
import { toWishlistPayload } from "@/utils/wishlist-payload";
import {
  wishlistStorageKeyForScope,
  migrateLegacyWishlistIntoKey,
} from "@/utils/shop-storage-scope";

export const useWishlistStore = defineStore("wishlist_product", () => {
  const wishlists = ref([]);

  function labelOf(p) {
    return p?.title || p?.product_name || "Product";
  }

  const sameId = (a, b) => String(a) === String(b);

  function persistWishlist() {
    try {
      const key = wishlistStorageKeyForScope();
      migrateLegacyWishlistIntoKey(key);
      localStorage.setItem(key, JSON.stringify(wishlists.value));
    } catch {
      /* ignore */
    }
  }

  const add_wishlist_product = (raw) => {
    const payload = toWishlistPayload(raw);
    if (!payload) {
      toast.error("Could not add this product to wishlist.");
      return;
    }
    const name = labelOf(payload);
    const idx = wishlists.value.findIndex((p) => sameId(p.id, payload.id));
    if (idx !== -1) {
      wishlists.value = wishlists.value.filter((p) => !sameId(p.id, payload.id));
      toast.info(`${name} removed from wishlist`);
    } else {
      wishlists.value.push(payload);
      toast.success(`${name} added to wishlist`);
    }
    persistWishlist();
  };

  const removeWishlist = (payload) => {
    if (!payload) return;
    const name = labelOf(payload);
    wishlists.value = wishlists.value.filter((p) => !sameId(p.id, payload.id));
    toast.info(`${name} removed from wishlist`);
    persistWishlist();
  };

  const initializeWishlistProducts = () => {
    const key = wishlistStorageKeyForScope();
    migrateLegacyWishlistIntoKey(key);
    try {
      const wishlistData = localStorage.getItem(key);
      if (wishlistData) {
        const parsed = JSON.parse(wishlistData);
        wishlists.value = Array.isArray(parsed) ? parsed : [];
      } else {
        wishlists.value = [];
      }
    } catch {
      wishlists.value = [];
    }
  };

  const clearSessionAfterLogout = () => {
    wishlists.value = [];
    try {
      localStorage.setItem(
        wishlistStorageKeyForScope(null),
        JSON.stringify([])
      );
      localStorage.removeItem("wishlist_products");
    } catch {
      /* ignore */
    }
  };

  return {
    add_wishlist_product,
    removeWishlist,
    initializeWishlistProducts,
    clearSessionAfterLogout,
    wishlists,
  };
});
